import Image from 'next/image';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import {
  excludedRegexList,
  getCategoryName,
  includedRegexList,
} from '../../../utils/getCategory';
import { If } from '../../Atoms/Conditionals';
import { HamburgerMenu } from '../../Header/HamburgerMenu';
import { myImageLoader, setQueryParamToLink } from '../../Header/utils';
import { NAV_TYPES } from '../../cms/layout/components/header';
import {
  COMPANY_OPTIONS,
  HEADER_LABELS,
  PRODUCT_OPTION,
  RESOURCES_OPTIONS,
  SOLUTIONS_OPTIONS,
} from './DataConstants';
import { DropdownComponent } from './Dropdown/DynamicDropdown';
import { GeneralColDropdownMobile } from './Dropdown/GeneralDropdownMobile';
import { TNAVBAR_DATA } from './types';

const MobileNavBar = ({
  logo,
  type,
  bgColor = '',
  rightCTA,
  isB2CPage = true,
}: TNAVBAR_DATA): JSX.Element => {
  const [active, setActive] = useState(false);
  const [logoURL, setLogoURL] = useState<string>('');

  const handleClick = () => {
    setActive(!active);
  };

  const header_labels = HEADER_LABELS;

  const router = useRouter();
  const pageName = getCategoryName({
    regexList: [...includedRegexList, ...excludedRegexList],
    url: router.asPath,
    parent: true,
  });
  const refValue = `${pageName}_pages_navbar`;

  useEffect(() => {
    const link = typeof logo.link === 'function' ? logo.link() : logo.link;
    const logoUrlString = typeof link === 'string' ? link : link.logoUrl;

    const logoLink = setQueryParamToLink(logoUrlString, 'utm_ref', refValue);
    setLogoURL(logoLink);
  }, [logo]);

  return (
    <>
      <div
        className={`${
          bgColor ? bgColor : 'bg-white'
        } p-3 w-full fixed z-20 font-medium sm:px-0 mobile-nav`}
        data-testid="Header"
      >
        <nav className="flex items-center z-20 gap-6 md:w-full sm:w-full font-medium wg-container">
          <a href={logoURL} className="inline-flex items-center p-0">
            <Image
              loader={() => myImageLoader(logo.icon)}
              src="me.png"
              alt="Picture of the author"
              width={64}
              height={20}
            />
          </a>

          <If condition={type !== NAV_TYPES.DEFAULT}>
            <DropdownComponent
              dropdownLabel={header_labels.products}
              dropdownList={PRODUCT_OPTION}
              topMenu={true}
              Dropdown={GeneralColDropdownMobile}
              classes="xl:hidden lg:hidden wd:hidden sm:p-0 sm:pr-2 "
            />

            <div
              className={
                'inline-flex rounded gap-2 md:hidden lg:hidden xl:hidden text-grey-850 ml-auto '
              }
            >
              <If condition={!isB2CPage}>
                <HamburgerMenu handleMenuClick={handleClick} isOpen={active} />
              </If>
              <If condition={isB2CPage}>{rightCTA}</If>
            </div>

            <div
              className={`hidden ${active ? 'sm:block' : ''}  w-full ${
                bgColor ? bgColor : 'bg-white'
              }`}
            >
              <div className="w-full">
                <If condition={type === NAV_TYPES.B2B}>
                  <DropdownComponent
                    dropdownLabel={header_labels.solutions}
                    dropdownList={SOLUTIONS_OPTIONS}
                    Dropdown={GeneralColDropdownMobile}
                    classes="sm:p-0 sm:w-full"
                  />
                </If>

                <DropdownComponent
                  dropdownLabel={header_labels.resources}
                  dropdownList={RESOURCES_OPTIONS}
                  Dropdown={GeneralColDropdownMobile}
                  classes="sm:p-0 sm:w-full"
                />
                <DropdownComponent
                  dropdownLabel={header_labels.company}
                  dropdownList={COMPANY_OPTIONS}
                  Dropdown={GeneralColDropdownMobile}
                  classes="sm:p-0 sm:w-full"
                />
              </div>
            </div>
          </If>
        </nav>
      </div>
      <div className="h-16 sm:h-12"></div>
    </>
  );
};

export { MobileNavBar };
